import { setAvatar } from "@/store/avatar-v1/avatarActions";
import {
  SAVED_AVATAR,
  CLOSE_AVATAR_UPLOAD,
  SAVE_AVATAR,
  OPEN_AVATAR_UPLOAD,
} from "@/store/avatar-v1/avatarConstants";
import { toast, toastI18n, getNotificationMsg } from "@/components/common/Toast";
import { SET_PROFILE_DATA_LOADED, setTellUsModalState } from "../metadata/metadataActions";
import { request, postImage } from "@/utils/api/legacyRequest";

export const EDIT_EXPERIENCE = "EDIT_EXPERIENCE";
export const SAVE_EXPERIENCE = "SAVE_EXPERIENCE";
export const ADD_EXPERIENCE = "ADD_EXPERIENCE";
export const DELETE_EXPERIENCE = "DELETE_EXPERIENCE";
export const RECEIVE_EXPERIENCE = "RECEIVE_EXPERIENCE";
export const TOGGLE_PRESENT = "TOGGLE_PRESENT";

// REWORKED
export const FETCHING_PROJECTS = "FETCHING_PROJECTS";
export const FETCHING_PROFILE = "FETCHING_PROFILE";
export const SET_PROFILE_ID = "SET_PROFILE_ID";
export const SET_LOCATION = "SET_LOCATION";
export const SET_PURPOSE = "SET_PURPOSE";
export const SET_SUMMARY = "SET_SUMMARY";
export const EDIT_SUMMARY = "EDIT_SUMMARY";
export const SAVE_SUMMARY = "SAVE_SUMMARY";
export const SET_META_DATA = "SET_META_DATA";
export const SET_SOCIAL_LINKS = "SET_SOCIAL_LINKS";
export const EDIT_SOCIAL_LINKS = "EDIT_SOCIAL_LINKS";
export const SAVE_SOCIAL_LINKS = "SAVE_SOCIAL_LINKS";

export const PROFILE_COMPLETED = "PROFILE_COMPLETED";

// reworked v2
export const SET_PROFILE_VISIBILITY = "profile/SET_PROFILE_VISIBILITY";

// *** EXPERIENCE *** //
export function toggleEditExperience(editId) {
  return {
    type: EDIT_EXPERIENCE,
    editId,
  };
}

export function toggleAddExperience() {
  return {
    type: ADD_EXPERIENCE,
  };
}

export function toggleSaveExperience() {
  return {
    type: SAVE_EXPERIENCE,
  };
}

export function receiveExperience(data) {
  return {
    type: RECEIVE_EXPERIENCE,
    data: {
      ...data,
    },
  };
}

export function fetchExperience() {
  return (dispatch, getState) => {
    const { user } = getState();
    const jwt = user.get("jwt");
    const expUrl = `${window?.env?.VITE_API_ENDPOINT || import.meta.env.VITE_API_ENDPOINT
      }/api/v1/rebel/user_profile/experiences`;

    request(expUrl, jwt, "GET").then((json) =>
      dispatch(receiveExperience(json))
    );
  };
}

export function deleteExperience(formId) {
  return (dispatch, getState) => {
    const { user } = getState();

    return fetch(
      `${window?.env?.VITE_API_ENDPOINT || import.meta.env.VITE_API_ENDPOINT
      }/api/v1/rebel/user_profile/experiences/${formId}`,
      {
        method: "DELETE",
        credentials: "same-origin",
        headers: {
          "Content-Type": "application/json",
          "x-csrf-token": window.csrfToken,
          Authorization: `Bearer ${user.get("jwt")}`,
        },
      }
    ).then(
      () => {
        dispatch(fetchExperience());
      },
      (error) => console.error("Error:", error)
    );
  };
}

export function submitExperience(values) {
  return /*withTranslation(['translation.notification']) (*/ (
    dispatch,
    getState
  ) => {
    const { user } = getState();
    return fetch(
      `${window?.env?.VITE_API_ENDPOINT || import.meta.env.VITE_API_ENDPOINT
      }/api/v1/rebel/user_profile/experiences`,
      {
        method: "POST",
        credentials: "same-origin",
        headers: {
          "Content-Type": "application/json",
          "x-csrf-token": window.csrfToken,
          Authorization: `Bearer ${user.get("jwt")}`,
        },
        body: JSON.stringify({ experience: values }),
      }
    ).then(
      () => {
        dispatch(toastI18n('success', 'ExperienceAdded'));
        dispatch(fetchExperience());
      },
      (error) => console.error("Error:", error)
    );
  };
}

export function editExperience(formId, values) {
  return /*withTranslation(['translation.notification']) (*/ (
    dispatch,
    getState
  ) => {
    const { user } = getState();

    return fetch(
      `${window?.env?.VITE_API_ENDPOINT || import.meta.env.VITE_API_ENDPOINT
      }/api/v1/rebel/user_profile/experiences/${formId}`,
      {
        method: "PATCH",
        credentials: "same-origin",
        headers: {
          "Content-Type": "application/json",
          "x-csrf-token": window.csrfToken,
          Authorization: `Bearer ${user.get("jwt")}`,
        },
        body: JSON.stringify({ experience: values }),
      }
    ).then(
      () => {
        dispatch(toastI18n('success', 'ExperienceSaved'));
        dispatch(fetchExperience());
      },
      (error) => console.error("Error:", error)
    );
  };
}

export function toggleCheckbox(expIndex) {
  return (dispatch, getState) => {
    const { experience } = getState();
    return {
      type: TOGGLE_PRESENT,
      present: !experience.data[expIndex].present,
      index: expIndex,
    };
  };
}

/*
 *
 * REWORKED ACTIONS
 *
 */

// Judge Bios
export const SET_REBEL_JUDGE_BIO = "rebel/SET_REBEL_JUDGE_BIO";

export function fetchJudgeBio() {
  return (dispatch, getState) => {
    const { user } = getState();

    const jwt = user.get("jwt");
    const url = `${window?.env?.VITE_API_ENDPOINT || import.meta.env.VITE_API_ENDPOINT
      }/api/v2/rebel/user-profile/judge-bios/${user.get("id")}`;
    return request(url, jwt).then((response) => {
      dispatch({ type: SET_REBEL_JUDGE_BIO, data: response.data });
    });
  };
}

export function postJudgeBio(values = {}, confirmSavePopup = false) {
  return (dispatch, getState) => {
    const { user } = getState();

    const judgeBioForm = values;

    if (judgeBioForm) {
      const payload = {
        judge_bio: {
          title: judgeBioForm.title ? judgeBioForm.title : null,
          bio: judgeBioForm.bio ? judgeBioForm.bio : null,
        },
      };

      const jwt = user.get("jwt");
      const url = `${window?.env?.VITE_API_ENDPOINT || import.meta.env.VITE_API_ENDPOINT
        }/api/v2/rebel/user-profile/judge-bios`;

      return request(url, jwt, "POST", payload).then((response) => {
        dispatch({ type: SET_REBEL_JUDGE_BIO, data: response.data });
        dispatch({ type: "UPDATE_JUDGE_BIO_SUCCESS", data: response.data });
        if (confirmSavePopup) {
          dispatch(toastI18n('success', 'JudgeBioSaved'));
        }
      });
    }
    return "";
  };
}

// summary
function setSummary(data) {
  return {
    type: SET_SUMMARY,
    data,
  };
}

export function editSummary() {
  return {
    type: EDIT_SUMMARY,
  };
}

export const RESET_EDITING_SUMMARY = "profile/RESET_EDITING_SUMMARY";
export function saveSummary(summary) {
  return /*withTranslation(['translation.notification']) (*/ (
    dispatch,
    getState
  ) => {
    dispatch({ type: SAVE_SUMMARY });
    const { user, profile } = getState();
    const jwt = user.get("jwt");
    const profileURL = `${window?.env?.VITE_API_ENDPOINT || import.meta.env.VITE_API_ENDPOINT
      }/api/v1/rebel/user_profile/rebel_profiles/${profile.profileId}`;
    const payload = {
      rebel_profile: {
        summary,
      },
    };
    request(profileURL, jwt, "PUT", payload)
      .then((response) => {
        dispatch(setSummary(response.data.summary));
        dispatch(toastI18n('success', 'AboutSaved'));
      })
      .catch((err) => console.error(err));
  };
}

export function setLocation(data) {
  if (!data)
    return {
      type: SET_LOCATION,
      data: {
        city: null,
        state: null,
      },
    };
  return {
    type: SET_LOCATION,
    data,
  };
}

export function setPurpose(data) {
  if (!data)
    return {
      type: SET_PURPOSE,
      data: {
        label: null,
      },
    };
  return {
    type: SET_PURPOSE,
    data,
  };
}

function setProfileId(data) {
  return {
    type: SET_PROFILE_ID,
    data,
  };
}

function setMetaData(data) {
  return {
    type: SET_META_DATA,
    data,
  };
}

function setSocialLinks(data) {
  return {
    type: SET_SOCIAL_LINKS,
    data,
  };
}

export const RESET_EDITING_SOCIAL_LINKS = "profile/RESET_EDITING_SOCIAL_LINKS";
export function editSocialLinks() {
  return {
    type: EDIT_SOCIAL_LINKS,
  };
}

export function saveSocialLinks(values = {}) {
  return /*withTranslation(['translation.notification']) (*/ (
    dispatch,
    getState
  ) => {
    dispatch({ type: SAVE_SOCIAL_LINKS });
    const { user } = getState();
    const jwt = user.get("jwt");
    const socialLinksURL = `${window?.env?.VITE_API_ENDPOINT || import.meta.env.VITE_API_ENDPOINT
      }/api/v1/rebel/user_profile/social_links`;

    let { linkedin } = values;
    if (linkedin) {
      if (linkedin[linkedin.length - 1] === "/")
        linkedin = linkedin.substring(0, linkedin.length - 1);
      linkedin = linkedin.substring(linkedin.lastIndexOf("/") + 1);
    }

    let { twitter } = values;
    if (twitter) {
      if (twitter[twitter.length - 1] === "/")
        twitter = twitter.substring(0, twitter.length - 1);
      twitter = twitter.substring(twitter.lastIndexOf("/") + 1);
    }

    let { facebook } = values;
    if (facebook) {
      if (facebook[facebook.length - 1] === "/")
        facebook = facebook.substring(0, facebook.length - 1);
      facebook = facebook.substring(facebook.lastIndexOf("/") + 1);
    }

    const payload = {
      data: {
        linkedin,
        twitter,
        facebook,
      },
    };

    return request(socialLinksURL, jwt, "POST", payload)
      .then((response) => {
        dispatch(setSocialLinks(response.data));
        dispatch(toastI18n('success', 'SocialLinksSaved'));
      })
      .catch((err) => console.error(err));
  };
}

function fetchSocialLinks(url, jwt) {
  return (dispatch) =>
    request(url, jwt)
      .then((response) => dispatch(setSocialLinks(response.data)))
      .catch((err) => console.error(err));
}

export function openAvatarUpload() {
  return {
    type: OPEN_AVATAR_UPLOAD,
  };
}

export function closeAvatarUpload() {
  return {
    type: CLOSE_AVATAR_UPLOAD,
  };
}

export function saveAvatar(file) {
  return /*withTranslation(['translation.notification']) (*/ (
    dispatch,
    getState
  ) => {
    const { user } = getState();
    const jwt = user.get("jwt");
    const url = `${window?.env?.VITE_API_ENDPOINT || import.meta.env.VITE_API_ENDPOINT
      }/api/v2/rebel/user-profile/rebel-profiles`;

    //validate;
    if (!file) {
      // return dispatch(popup('Please select an image.', 'error', null, 'tc', 5));
      return false;
    }

    dispatch({ type: SAVE_AVATAR });
    // multipart forms need this data structure
    const formData = new FormData();
    formData.append("_utf8", true);
    formData.append("rebel_profile[avatar]", file);

    return postImage(url, jwt, "POST", formData).then((res) => {
      if (res.status === 500) {
        dispatch({
          type: SAVED_AVATAR,
        });
        return dispatch(toastI18n('error', 'SupportedFormats'));
      }
      res.json().then((respone) => {
        dispatch(setAvatar(respone.data.avatar_url, user.get("id")));
        dispatch({
          type: SET_PROFILE_DATA_LOADED,
        });
        dispatch({
          type: CLOSE_AVATAR_UPLOAD,
        });
        dispatch(toastI18n('success', 'ProfileImageUploaded'));
        dispatch({
          type: SAVED_AVATAR,
        });
      });
      return "";
    });
  };
}

export function profileCompleted() {
  return /*withTranslation(['translation.notification']) (*/ (
    dispatch,
    getState
  ) => {
    dispatch({ type: PROFILE_COMPLETED });
    dispatch(toastI18n('success', 'AwsomeWorks'));

    const { profile, user } = getState();
    const jwt = user.get("jwt");
    const profileURL = `${window?.env?.VITE_API_ENDPOINT || import.meta.env.VITE_API_ENDPOINT
      }/api/v1/rebel/user_profile/rebel_profiles/${profile.profileId}`;
    const payload = {
      rebel_profile: {
        metadata: {
          isProfileComplete: true,
        },
      },
    };

    request(profileURL, jwt, "PUT", payload);
  };
}

// Visibility
function setProfileVisibility(value) {
  return {
    type: SET_PROFILE_VISIBILITY,
    value,
  };
}

function fetchProfile(
  url = `${window?.env?.VITE_API_ENDPOINT || import.meta.env.VITE_API_ENDPOINT
    }/api/v1/rebel/user_profile/rebel_profiles`,
  jwt
) {
  return (dispatch, getState) => {
    const { user, metadata } = getState();
    dispatch({ type: FETCHING_PROFILE });
    dispatch(fetchJudgeBio());
    return request(url, jwt)
      .then((response) => {
        // check if tell us page is complete
        if (!metadata.isSignup && !response.data.location_map) {
          dispatch(
            toast.warning(getNotificationMsg('TellUs'), {
              hideDuration: null,
              action: {
                label: getNotificationMsg('ClickHere'),
                fn: () => dispatch(setTellUsModalState(true)),
              },
            })
          );
        } else {
          dispatch(setLocation(response.data.location_map));
          dispatch(setPurpose(response.data.purpose));
        }
        dispatch(setProfileId(response.data.id));
        dispatch(setSummary(response.data.summary));
        dispatch(setAvatar(response.data.avatar_url, user.get("id")));
        dispatch(setMetaData(response.data.metadata));
        dispatch(setProfileVisibility(response.data.is_public));
      })
      .catch((err) => console.error(err));
  };
}

export function fetchProfileData() {
  return (dispatch, getState) => {
    const jwt = getState().user.get("jwt");
    const profileURL = `${window?.env?.VITE_API_ENDPOINT || import.meta.env.VITE_API_ENDPOINT
      }/api/v1/rebel/user_profile/rebel_profiles`;
    // const experienceURL = window?.env?.VITE_API_ENDPOINT || import.meta.env.VITE_API_ENDPOINT+'/api/v1/rebel/user_profile/experiences';
    const socialLinksURL = `${window?.env?.VITE_API_ENDPOINT || import.meta.env.VITE_API_ENDPOINT
      }/api/v1/rebel/user_profile/social_links/`;
    Promise.all([
      dispatch(fetchProfile(profileURL, jwt)),
      dispatch(fetchSocialLinks(socialLinksURL, jwt)),
    ]).then(() => dispatch({ type: SET_PROFILE_DATA_LOADED }));
  };
}

export function toggleProfileVisibility(isPublic) {
  return (dispatch, getState) => {
    const { user, profile } = getState();
    const jwt = user.get("jwt");
    const profileURL = `${window?.env?.VITE_API_ENDPOINT || import.meta.env.VITE_API_ENDPOINT
      }/api/v1/rebel/user_profile/rebel_profiles/${profile.profileId}`;
    const payload = {
      rebel_profile: {
        is_public: isPublic,
      },
    };
    request(profileURL, jwt, "PUT", payload)
      .then((response) => {
        dispatch(setProfileVisibility(response.data.is_public));
      })
      .catch((err) => console.error(err));
  };
}
